<template>
  <section class="value">
    <SectionCover
      :img="getImageOrientation(coverImage)"
      v-scroll-nav="{ path: '/value' }"
      next-arrow
    >
      <div v-html="$t('value-title', { year: $config.year })" v-animate-in></div>
    </SectionCover>
    <Quote :quote="quote.boschetti" v-if="quote" v-scroll-nav="{ path: '/value/quote-b' }" />
    <RecapCover />
    <div class="activities" v-if="activities">
      <Activity v-for="(activity, id) in activities" :key="id" :activity="activity" />
    </div>
    <Quote :quote="quote.gavosto" v-if="quote" v-scroll-nav="{ path: '/value/quote-a' }" />
  </section>
</template>

<script>
import SectionCover from '@/components/common/SectionCover';
import RecapCover from '@/views/value/RecapCover';
import Activity from './Activity';
import Quote from '@/components/common/Quote';
import imageMixin from '@/plugins/image-mixin';
import section from '@/assets/data/activities/section';

export default {
  name: 'Value',
  mixins: [imageMixin],
  components: { SectionCover, RecapCover, Activity, Quote },
  data() {
    return {
      quote: section.quote,
      coverImage: this.getImageOrientation(section.cover)
    };
  },
  computed: {
    activities() {
      return this.$store.getters['activities/list'];
    }
  }
};
</script>

<style lang="scss" scoped>
.value {
  /deep/ {
    .section-cover {
      .section-title {
        background-color: $col-red-light;
      }
      .title em {
        color: $col-navy-dark;
      }
    }
  }
}
</style>
